import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ModalContainer from "./../../ModalContainer";
import {
  CORPORATE_CUSTOMER_ICON,
  INDIVIDUAL_CUSTOMER_ICON,
} from "./../../../../constants/svgs/SVGS";
import { useRef } from "react";
import { setApplicationType } from "../../../../redux/slice/customer/customerSlice";
import { onlySpaces } from "./../../../../utils/validators/validators";
import { flashMessage as flash } from "./../../../../utils/flash/index";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const CustomerType = ({ modal_id }) => {
  const [createCorporateCustomer, setCreateCorporateCustomer] = useState(null);
  const [createIndividualCustomer, setCreateIndividualCustomer] =
    useState(null);
  const [customerType, setCustomerType] = useState("");
  const { user } = useSelector((state) => state.auth);
  const { application_info } = useSelector((state) => state.customer);
  const closeRef = useRef("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const customerTypeHandler = () => {
    if (onlySpaces(customerType)) {
      flash("error", "Please choose application type");
    } else {
      dispatch(
        setApplicationType({
          customer_type: customerType,
          isSetCustomerType: true,
        })
      );
    }
  };

  useEffect(() => {
    if (
      application_info?.customer_type?.length > 0 &&
      application_info?.isSetCustomerType == true
    ) {
      closeRef.current.click();
      // navigate('/admin/add-customer')
      navigate("/admin/add-customer", {
        state: { from: location },
        replace: true,
      });
    }
  }, [application_info]);

  // useEffect(() => {
  //     dispatch(setApplicationType(''))
  // },[])

  useEffect(() => {
    setCreateIndividualCustomer(
      user?.user_permissions?.some(
        (permission) => permission.name === "create customers - individual"
      )
    );
    setCreateCorporateCustomer(
      user?.user_permissions?.some(
        (permission) => permission.name === "create customer - corporate"
      )
    );
  }, [user?.user_permissions]);

  return (
    <ModalContainer modal_id={modal_id} bradius='rounded-4'>
      <div className='container p-4'>
        <div className='my-3 text-center'>
          <h3 className='text-dark'>Add new customer</h3>
          <p className='lh-sm fs-5'>
            Select the type of customer you want to create below
          </p>
          <div className='content mt-3'>
            {createCorporateCustomer && (
              <div
                className={`${
                  customerType !== "Corporate"
                    ? "bg-white border-primary-1"
                    : "bg-primary-1"
                } rounded-3 cursor-p`}
                onClick={() => setCustomerType("Corporate")}
              >
                <div className='d-flex p-2'>
                  <span
                    className={`${
                      customerType !== "Corporate" ? "bg-primary-1" : "bg-white"
                    } p-2 rounded-3`}
                  >
                    <CORPORATE_CUSTOMER_ICON
                      color={`${
                        customerType !== "Corporate" ? "#FFF" : "#2E3192"
                      }`}
                    />
                  </span>
                  <div className='ms-2'>
                    <span
                      className={`${
                        customerType !== "Corporate"
                          ? "text-primary-1"
                          : "text-white"
                      } fw-bold d-block text-start`}
                    >
                      Corporate
                    </span>
                    <span
                      className={`${
                        customerType !== "Corporate"
                          ? "text-primary-1"
                          : "text-white"
                      }`}
                    >
                      {" "}
                      For companies and Entrepreneurs{" "}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {createIndividualCustomer && (
              <div
                className={`${
                  customerType !== "Individual"
                    ? "bg-white border-primary-1"
                    : "bg-primary-1"
                } rounded-3 cursor-p mt-3`}
                onClick={() => setCustomerType("Individual")}
              >
                <div className='d-flex p-2'>
                  <span
                    className={`${
                      customerType !== "Individual"
                        ? "bg-primary-1"
                        : "bg-white"
                    } p-2 rounded-3`}
                  >
                    <INDIVIDUAL_CUSTOMER_ICON
                      color={`${
                        customerType !== "Individual" ? "#FFF" : "#2E3192"
                      }`}
                    />
                  </span>
                  <div className='ms-2'>
                    <span
                      className={`${
                        customerType !== "Individual"
                          ? "text-primary-1"
                          : "text-white"
                      } fw-bold d-block text-start`}
                    >
                      Individual
                    </span>
                    <span
                      className={`${
                        customerType !== "Individual"
                          ? "text-primary-1"
                          : "text-white"
                      }`}
                    >
                      {" "}
                      For individual customers{" "}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='d-grid'>
            <button
              ref={closeRef}
              className='btn p-2 px-4 rounded-2 text-muted'
              data-bs-dismiss='modal'
              style={{ background: "#F1F0F1" }}
            >
              Cancel
            </button>
          </div>
          <div className='d-grid'>
            <button
              onClick={() => customerTypeHandler(customerType)}
              className='btn bg-primary-1 text-white p-2 px-4 rounded-2'
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default CustomerType;
